import { Component } from "@angular/core";
import { Router, RouterEvent, NavigationEnd } from "@angular/router";
import { HeaderItem } from "./base/header/model/header-item.model";
import { filter } from "rxjs/operators";
import { FileLoaderService } from "./services/file-loader.service";
import { News } from "./base/news-post/model/news.model";
import { DownloadService } from "./base/services/download.service";

declare let ga: Function;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  menuItems = [
    new HeaderItem("Főoldal", "main", null),
    new HeaderItem("Önkormányzat", "", [
      new HeaderItem("Dunaszentmiklósi Önkormányzat", "main-council", null),
      new HeaderItem("Nemzetiségi Önkormányzat", "nationality-council", null),
    ]),
    new HeaderItem("Látnivalók", "sights", null),
    new HeaderItem("Kapcsolat", "contacts", null),
    new HeaderItem("Választási információk", "", [
      new HeaderItem("Választási szervek", "election-details", null),
      new HeaderItem("2024. évi általános választások", "election-2024", null),
      new HeaderItem(
        "Választási ügyintézés",
        undefined,
        null,
        "http://www.valasztas.hu/ugyintezes"
      ),
      new HeaderItem("Időközi választás", "election", null),
      new HeaderItem("HVB határozatok", "hvb", null),
    ]),
    new HeaderItem("Közérdekű adatok", "common-datas", null),
  ];

  title = "Dunaszentmiklos";
  isMainPage = true;
  hideSzechenyi = false;
  hidePrivacy = false;
  vision = false;
  news: Array<News> = [];
  now = new Date();

  constructor(
    private router: Router,
    private fileLoader: FileLoaderService,
    private downloadService: DownloadService
  ) {
    router.events
      .pipe(filter((e) => e instanceof RouterEvent))
      .subscribe((e: any) => {
        this.isMainPage =
          e.url.indexOf("/main") > -1 && e.url.indexOf("main-") === -1;
        if (!this.isMainPage) {
          this.vision = false;
        }
        if (ga && event instanceof NavigationEnd) {
          ga("set", "page", event.urlAfterRedirects);
          ga("send", "pageview");
        }
      });
  }

  visionClick() {
    this.vision = true;
    this.router.navigate(["/main"]);
    this.loadNews();
  }

  loadNews() {
    this.fileLoader.getNews().subscribe((news) => {
      this.news = news;
    });
  }

  download(name: string, ext: string = null, path: string = null) {
    this.downloadService.download(path, name, ext);
  }
}
